<p class="text-bold">
	<mat-spinner style="margin: 0 auto;"></mat-spinner>
</p>